export const longMaxAge = 60 * 60 * 24 * 365;